import type { SalesStage } from '../../../api';

const OPS_MACRO_OPEN: SalesStage[] = [
  'paid',
  'measurement',
  'measurement_done',
  'compose',
  'production',
  'ready_to_ship',
  'fulfillment',
];

export type CrmDealMacroId = 'sales' | 'compose' | 'ops';

/** Все макро-секции карточки сделки закрыты по умолчанию; раскрытие — по тапу. */
export function defaultMacroOpen(
  _stage: SalesStage,
  _opts: { productionRead: boolean; isLead: boolean },
): Record<CrmDealMacroId, boolean> {
  return { sales: false, compose: false, ops: false };
}

export function salesStageUsesOpsMacro(stage: SalesStage): boolean {
  return OPS_MACRO_OPEN.includes(stage);
}
